import { loadAmdModule } from '@utils/common';
import { scriptsConfig as config } from '@utils/scriptsConfig';

export const loadUtilScript = async (key, canReuse = value => Boolean(value)) => {
  if (!config[key]) throw new Error(`${key} not found.`);

  const { key: wKey, js } = config[key];
  if (canReuse(window[wKey])) return window[wKey];

  const instance = await loadAmdModule(js, key);
  window[wKey] = instance;
  return instance;
};

export const loadEcharts = () => loadUtilScript('echarts');

const canReuseXLSX = xlsx => (
  typeof xlsx?.utils?.json_to_sheet === 'function'
  && typeof xlsx?.write === 'function'
);

export const loadXLSX = () => loadUtilScript('xlsx', canReuseXLSX);

export const loadJstt = async () => {
  await loadUtilScript('jstt');
  return window.jstt;
};
